import { CookieHandlerHelper } from '../../helpers';

export const haveAcceptedCookies = () => CookieHandlerHelper.get('cookies-consent') === 'true';
export const acceptOrDeclineCookies = (accepted = false) =>
  CookieHandlerHelper.set('cookies-consent', String(accepted));
